<template>
    <div class="coal-tax-calc" style="padding: 10px;">
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card shadow="hover">
                    <div slot="header" style="display:flex;align-items:center;justify-content:space-between;">
                        <span>{{ $t('pages.coalTaxCalc.title') }}</span>
                        <div>
                            <el-button size="mini" type="primary" @click="calculate">{{ $t('pages.coalTaxCalc.calculate') }}</el-button>
                           <!-- <el-button size="mini" @click="fillDemo">{{ $t('pages.coalTaxCalc.fillDemo') }}</el-button>-->
                            <el-button size="mini" @click="reset">{{ $t('common.reset') }}</el-button>
                        </div>
                    </div>
                    <el-form :model="form" label-width="160px">
                        <el-form-item :label="$t('pages.coalTaxCalc.grossCoalT')">
                            <el-input-number v-model="form.grossCoalT" :min="0" :max="100000000" :step="10" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.convertCoeff')">
                            <el-input-number v-model="form.convertCoeff" :min="0" :max="1" :step="0.01" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.qnetKcalKg')">
                            <el-input-number v-model="form.qnetKcalKg" :min="0" :max="9000" :step="50" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item :label="$t('pages.coalTaxCalc.unitPriceExVat')">
                            <el-input-number v-model="form.unitPriceExVat" :min="0" :max="100000" :step="10" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.vatRate')">
                            <el-input-number v-model="form.vatRate" :min="0" :max="100" :step="1" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.resourceTaxRate')">
                            <el-input-number v-model="form.resourceTaxRate" :min="0" :max="100" :step="0.5" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.citySurtaxRate')">
                            <el-input-number v-model="form.citySurtaxRate" :min="0" :max="100" :step="0.5" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.eduSurtaxRate')">
                            <el-input-number v-model="form.eduSurtaxRate" :min="0" :max="100" :step="0.5" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.localEduSurtaxRate')">
                            <el-input-number v-model="form.localEduSurtaxRate" :min="0" :max="100" :step="0.5" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-divider></el-divider>
                        <el-form-item :label="$t('pages.coalTaxCalc.safetyFundPerTon')">
                            <el-input-number v-model="form.safetyFundPerTon" :min="0" :max="100000" :step="1" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.envFundPerTon')">
                            <el-input-number v-model="form.envFundPerTon" :min="0" :max="100000" :step="1" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('pages.coalTaxCalc.otherFundRate')">
                            <el-input-number v-model="form.otherFundRate" :min="0" :max="100" :step="0.5" :precision="2" controls-position="right" style="width: 220px;"></el-input-number>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card shadow="hover">
                    <div slot="header">{{ $t('pages.coalTaxCalc.resultTitle') }}</div>
                    <div v-if="!result" style="color:#999;line-height:22px;">
                        {{ $t('pages.coalTaxCalc.resultEmpty') }}
                    </div>
                    <div v-else>
                        <div style="font-weight:600;color:#666;margin-bottom:8px;">{{ $t('pages.coalTaxCalc.summaryTableTitle') }}</div>
                        <el-table :data="resultRows" size="mini" border :show-header="true" :row-class-name="rowClassName">
                            <el-table-column prop="name" :label="$t('pages.coalTaxCalc.colName')" min-width="150"></el-table-column>
                            <el-table-column prop="value" :label="$t('pages.coalTaxCalc.colValue')" min-width="160">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.value }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="unit" :label="$t('pages.coalTaxCalc.colUnit')" width="90"></el-table-column>
                            <el-table-column prop="formula" :label="$t('pages.coalTaxCalc.colFormula')" min-width="220"></el-table-column>
                        </el-table>
                        <el-divider></el-divider>
                        <div style="font-weight:600;color:#666;margin-bottom:8px;">{{ $t('pages.coalTaxCalc.detailTableTitle') }}</div>
                        <el-table :data="taxFeeRows" size="mini" border height="420">
                            <el-table-column prop="name" :label="$t('pages.coalTaxCalc.colName')" min-width="130"></el-table-column>
                            <el-table-column prop="base" :label="$t('pages.coalTaxCalc.colBase')" min-width="140">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.baseText }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="rate" :label="$t('pages.coalTaxCalc.colRate')" width="110"></el-table-column>
                            <el-table-column prop="amount" :label="$t('pages.coalTaxCalc.colAmount')" min-width="140">
                                <template slot-scope="scope">
                                    <span>{{ fmtMoney(scope.row.amount) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="note" :label="$t('pages.coalTaxCalc.colNote')" min-width="160"></el-table-column>
                        </el-table>
                    </div>
                    <div style="margin-top:10px;color:#999;line-height:22px;">
                        <div>{{ $t('pages.coalTaxCalc.logicHint1') }}</div>
                        <div>{{ $t('pages.coalTaxCalc.logicHint2') }}</div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: this.getDefaultForm(),
            result: null
        };
    },
    computed: {
        resultRows() {
            if (!this.result) {
                return [];
            }
            return [{
                    isGroup: true,
                    name: this.$t('pages.coalTaxCalc.groupConversion'),
                    value: '',
                    unit: '',
                    formula: ''
                },
                {
                    name: this.$t('pages.coalTaxCalc.grossCoalT'),
                    value: this.fmt(this.form.grossCoalT),
                    unit: 't',
                    formula: this.$t('pages.coalTaxCalc.formulaInput')
                },
                {
                    name: this.$t('pages.coalTaxCalc.convertCoeff'),
                    value: this.fmt(this.form.convertCoeff),
                    unit: '-',
                    formula: this.$t('pages.coalTaxCalc.formulaInput')
                },
                {
                    name: this.$t('pages.coalTaxCalc.rawCoalT'),
                    value: this.fmt(this.result.rawCoalT),
                    unit: 't',
                    formula: this.$t('pages.coalTaxCalc.formulaRawCoalT')
                },
                {
                    name: this.$t('pages.coalTaxCalc.qnetKcalKg'),
                    value: this.fmt(this.form.qnetKcalKg),
                    unit: 'kcal/kg',
                    formula: this.$t('pages.coalTaxCalc.formulaInput')
                },
                {
                    name: this.$t('pages.coalTaxCalc.stdCoalT'),
                    value: this.fmt(this.result.stdCoalT),
                    unit: this.$t('pages.coalTaxCalc.tceUnit'),
                    formula: this.$t('pages.coalTaxCalc.formulaStdCoalT')
                },
                {
                    isGroup: true,
                    name: this.$t('pages.coalTaxCalc.groupSettlement'),
                    value: '',
                    unit: '',
                    formula: ''
                },
                {
                    name: this.$t('pages.coalTaxCalc.unitPriceExVat'),
                    value: this.fmtMoney(this.form.unitPriceExVat),
                    unit: this.$t('pages.coalTaxCalc.yuanPerTon'),
                    formula: this.$t('pages.coalTaxCalc.formulaInput')
                },
                {
                    name: this.$t('pages.coalTaxCalc.salesExVat'),
                    value: this.fmtMoney(this.result.salesExVat),
                    unit: this.$t('pages.coalTaxCalc.yuan'),
                    formula: this.$t('pages.coalTaxCalc.formulaSalesExVat')
                },
                {
                    name: this.$t('pages.coalTaxCalc.vatAmount'),
                    value: this.fmtMoney(this.result.vatAmount),
                    unit: this.$t('pages.coalTaxCalc.yuan'),
                    formula: this.$t('pages.coalTaxCalc.formulaVat')
                },
                {
                    name: this.$t('pages.coalTaxCalc.salesIncVat'),
                    value: this.fmtMoney(this.result.salesIncVat),
                    unit: this.$t('pages.coalTaxCalc.yuan'),
                    formula: this.$t('pages.coalTaxCalc.formulaSalesIncVat')
                },
                {
                    name: this.$t('pages.coalTaxCalc.totalOtherTaxFee'),
                    value: this.fmtMoney(this.result.totalOtherTaxFee),
                    unit: this.$t('pages.coalTaxCalc.yuan'),
                    formula: this.$t('pages.coalTaxCalc.formulaOtherTaxFee')
                },
                {
                    name: this.$t('pages.coalTaxCalc.totalTaxFee'),
                    value: this.fmtMoney(this.result.totalTaxFee),
                    unit: this.$t('pages.coalTaxCalc.yuan'),
                    formula: this.$t('pages.coalTaxCalc.formulaTotalTaxFee')
                },
                {
                    name: this.$t('pages.coalTaxCalc.netExVatAfterTaxFee'),
                    value: this.fmtMoney(this.result.netExVatAfterTaxFee),
                    unit: this.$t('pages.coalTaxCalc.yuan'),
                    formula: this.$t('pages.coalTaxCalc.formulaNetSettle')
                }
            ];
        },
        taxFeeRows() {
            if (!this.result) {
                return [];
            }
            const rows = [{
                    name: this.$t('pages.coalTaxCalc.resourceTax'),
                    baseText: this.$t('pages.coalTaxCalc.baseSalesExVat'),
                    rate: `${this.form.resourceTaxRate}%`,
                    amount: this.result.resourceTaxAmount,
                    note: this.$t('pages.coalTaxCalc.noteRateOnSales')
                },
                {
                    name: this.$t('pages.coalTaxCalc.vat'),
                    baseText: this.$t('pages.coalTaxCalc.baseSalesExVat'),
                    rate: `${this.form.vatRate}%`,
                    amount: this.result.vatAmount,
                    note: this.$t('pages.coalTaxCalc.noteVatOutput')
                },
                {
                    name: this.$t('pages.coalTaxCalc.citySurtax'),
                    baseText: this.$t('pages.coalTaxCalc.baseVat'),
                    rate: `${this.form.citySurtaxRate}%`,
                    amount: this.result.citySurtaxAmount,
                    note: this.$t('pages.coalTaxCalc.noteSurtaxOnVat')
                },
                {
                    name: this.$t('pages.coalTaxCalc.eduSurtax'),
                    baseText: this.$t('pages.coalTaxCalc.baseVat'),
                    rate: `${this.form.eduSurtaxRate}%`,
                    amount: this.result.eduSurtaxAmount,
                    note: this.$t('pages.coalTaxCalc.noteSurtaxOnVat')
                },
                {
                    name: this.$t('pages.coalTaxCalc.localEduSurtax'),
                    baseText: this.$t('pages.coalTaxCalc.baseVat'),
                    rate: `${this.form.localEduSurtaxRate}%`,
                    amount: this.result.localEduSurtaxAmount,
                    note: this.$t('pages.coalTaxCalc.noteSurtaxOnVat')
                },
                {
                    name: this.$t('pages.coalTaxCalc.safetyFund'),
                    baseText: this.$t('pages.coalTaxCalc.baseRawCoal'),
                    rate: `${this.form.safetyFundPerTon}${this.$t('pages.coalTaxCalc.yuanPerTon')}`,
                    amount: this.result.safetyFundAmount,
                    note: this.$t('pages.coalTaxCalc.notePerTonOnRaw')
                },
                {
                    name: this.$t('pages.coalTaxCalc.envFund'),
                    baseText: this.$t('pages.coalTaxCalc.baseRawCoal'),
                    rate: `${this.form.envFundPerTon}${this.$t('pages.coalTaxCalc.yuanPerTon')}`,
                    amount: this.result.envFundAmount,
                    note: this.$t('pages.coalTaxCalc.notePerTonOnRaw')
                },
                {
                    name: this.$t('pages.coalTaxCalc.otherFund'),
                    baseText: this.$t('pages.coalTaxCalc.baseSalesExVat'),
                    rate: `${this.form.otherFundRate}%`,
                    amount: this.result.otherFundAmount,
                    note: this.$t('pages.coalTaxCalc.noteConfigurableExample')
                }
            ];
            rows.push({
                name: this.$t('pages.coalTaxCalc.subtotalRow'),
                baseText: '-',
                rate: '-',
                amount: this.result.totalOtherTaxFee,
                note: this.$t('pages.coalTaxCalc.subtotalRowNote')
            });
            rows.push({
                name: this.$t('pages.coalTaxCalc.totalRow'),
                baseText: '-',
                rate: '-',
                amount: this.result.totalTaxFee,
                note: this.$t('pages.coalTaxCalc.totalRowNote')
            });
            return rows;
        }
    },
    methods: {
        rowClassName({
            row
        }) {
            return row && row.isGroup ? 'coal-tax-group-row' : '';
        },
        getDefaultForm() {
            return {
                grossCoalT: 1000,
                convertCoeff: 0.92,
                qnetKcalKg: 5000,
                unitPriceExVat: 600,
                vatRate: 13,
                resourceTaxRate: 5,
                citySurtaxRate: 7,
                eduSurtaxRate: 3,
                localEduSurtaxRate: 2,
                safetyFundPerTon: 10,
                envFundPerTon: 5,
                otherFundRate: 1
            };
        },
        reset() {
            this.form = this.getDefaultForm();
            this.result = null;
        },
        fillDemo() {
            this.form = {
                grossCoalT: 15000,
                convertCoeff: 0.93,
                qnetKcalKg: 5200,
                unitPriceExVat: 650,
                vatRate: 13,
                resourceTaxRate: 5,
                citySurtaxRate: 7,
                eduSurtaxRate: 3,
                localEduSurtaxRate: 2,
                safetyFundPerTon: 12,
                envFundPerTon: 6,
                otherFundRate: 1.5
            };
        },
        calculate() {
            const grossCoalT = parseFloat(this.form.grossCoalT) || 0;
            const convertCoeff = parseFloat(this.form.convertCoeff) || 0;
            const qnetKcalKg = parseFloat(this.form.qnetKcalKg) || 0;
            const unitPriceExVat = parseFloat(this.form.unitPriceExVat) || 0;

            const rawCoalT = this.round2(grossCoalT * convertCoeff);
            const stdCoalT = this.round2(rawCoalT * (qnetKcalKg / 7000));
            const salesExVat = this.round2(rawCoalT * unitPriceExVat);

            const vatRate = (parseFloat(this.form.vatRate) || 0) / 100;
            const resourceTaxRate = (parseFloat(this.form.resourceTaxRate) || 0) / 100;
            const citySurtaxRate = (parseFloat(this.form.citySurtaxRate) || 0) / 100;
            const eduSurtaxRate = (parseFloat(this.form.eduSurtaxRate) || 0) / 100;
            const localEduSurtaxRate = (parseFloat(this.form.localEduSurtaxRate) || 0) / 100;
            const otherFundRate = (parseFloat(this.form.otherFundRate) || 0) / 100;
            const safetyFundPerTon = parseFloat(this.form.safetyFundPerTon) || 0;
            const envFundPerTon = parseFloat(this.form.envFundPerTon) || 0;

            const vatAmount = this.round2(salesExVat * vatRate);
            const resourceTaxAmount = this.round2(salesExVat * resourceTaxRate);
            const citySurtaxAmount = this.round2(vatAmount * citySurtaxRate);
            const eduSurtaxAmount = this.round2(vatAmount * eduSurtaxRate);
            const localEduSurtaxAmount = this.round2(vatAmount * localEduSurtaxRate);
            const safetyFundAmount = this.round2(rawCoalT * safetyFundPerTon);
            const envFundAmount = this.round2(rawCoalT * envFundPerTon);
            const otherFundAmount = this.round2(salesExVat * otherFundRate);

            const totalOtherTaxFee = this.round2(
                resourceTaxAmount +
                citySurtaxAmount +
                eduSurtaxAmount +
                localEduSurtaxAmount +
                safetyFundAmount +
                envFundAmount +
                otherFundAmount
            );
            const salesIncVat = this.round2(salesExVat + vatAmount);
            const totalTaxFee = this.round2(totalOtherTaxFee + vatAmount);
            const netExVatAfterTaxFee = this.round2(salesExVat - totalOtherTaxFee);

            this.result = {
                rawCoalT,
                stdCoalT,
                salesExVat,
                vatAmount,
                salesIncVat,
                totalOtherTaxFee,
                totalTaxFee,
                netExVatAfterTaxFee,
                resourceTaxAmount,
                citySurtaxAmount,
                eduSurtaxAmount,
                localEduSurtaxAmount,
                safetyFundAmount,
                envFundAmount,
                otherFundAmount
            };
        },
        round2(v) {
            return Math.round((v + Number.EPSILON) * 100) / 100;
        },
        fmt(v) {
            const n = Number(v);
            if (!Number.isFinite(n)) {
                return '0.00';
            }
            return new Intl.NumberFormat('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(n);
        },
        fmtMoney(v) {
            return this.fmt(v);
        }
    }
};
</script>

<style>
.coal-tax-calc .el-descriptions-item__label {
    font-weight: 600;
}

.coal-tax-calc .el-descriptions-item__content {
    font-weight: 600;
}

.coal-tax-calc .coal-tax-group-row td {
    background: #f5f7fa;
    font-weight: 700;
    color: #666;
}
</style>
